import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, validateEmail, getRemotedbUrl, milesNumber, throwErrorEvent } from '../../lib/ep.js';

import ActionButton, { SecondaryButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import DateTimePicker from '../builder/DateTimePicker';
import EmailField from '../builder/EmailField';
import FloatingLayer from '../builder/FloatingLayer';
import FloatingLayerPublic from '../front/FloatingLayerPublic';
import Message, { AlertMessage, InformationMessage, SuccessMessage } from '../builder/Message';
import NavigationTabs from '../builder/NavigationTabs';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';
import { isMultiStage, with_score } from '../../data/bootstrap_stages.js';
import Input from '../builder/Input.js';
import Checkbox from '../builder/Checkbox.js';

const ExportModalDownloadCenter = ({toggle, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const [ error_message, setErrorMessage ] = useState(false);
	const [ success_message, setSuccessMessage ] = useState(false);
	let export_button_disabled = false;
	let Component = FloatingLayer;

	const title = props?.title ?? i18n("Export data");
	const subtitle =  props?.subtitle ?? i18n("A CSV file will be generated, and notification will be sent via email to download it.")
	const messageOK = props.intl.formatMessage({ id:"The task may take a few minutes. Once the task is completed, a notification will be sent to the email {email}." }, { email:`<strong>${props.agent_email}</strong>`});

	let floating_props = {};
	if(toggle) floating_props.backButton = () => toggle(false);
	floating_props._class = {size:'small'}

	const download_csv = (cb) => {
		const type = props?.type ?? null;
		if(!type)return null; 
		let send_info = {type};
		
		if(props.email != undefined) send_info.email = props.agent_email;
		if(props.filename != undefined) send_info.filename = props.filename;

		$.post(getRemotedbUrl(`/v24/export/sweeps/${props.account_id}`), send_info, (result) => {
			if(result.status){
				setSuccessMessage(true);
			} else {
				setErrorMessage(result);
			}
			if(cb != undefined)cb();
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	}

	if(success_message) {
		return (
			<Component {...floating_props}>
				<div class="gui_filter_layer">
					<div class="gui_pos_rel">
						<SectionTitle _class={{icon:'knk-download'}} autotranslate={false}>{title}</SectionTitle>

						{(subtitle) && (
							<SectionSubtitle autotranslate={false}>{subtitle}</SectionSubtitle>
						)}

						<SuccessMessage
							_class={{ other:'in_bottom' }}
							title="In process"
						>
							<p>{i18n("Your request has been queued for download.")}</p>

							<p dangerouslySetInnerHTML={{ __html:messageOK}} />

							<p>{props.message_download_center}</p>
						</SuccessMessage>
					</div>

					<ExportModalActions>
						<SecondaryButton
							onClick={() => {
								toggle(false);
							}}
						>Close</SecondaryButton>
					</ExportModalActions>
				</div>
			</Component>
		)
	}

	return (
		<Component {...floating_props}>
			<div class="gui_filter_layer">
				<div class="gui_pos_rel">
					<SectionTitle _class={{icon:'knk-download'}} autotranslate={false}>{title}</SectionTitle>

					{(subtitle) && (
						<SectionSubtitle autotranslate={false}>{subtitle}</SectionSubtitle>
					)}
				</div>
				<ExportModalActions>
					<SaveButton
						disabled={(export_button_disabled) ? true : false}
						onClick={(e, cb) => download_csv(cb)}
						_class={{other:'original_color_item'}}
					>Download now</SaveButton>
				</ExportModalActions>
			</div>
		</Component>
	)
}

const ExportModalActions = (props) => {
	const is_public = props?.is_public ?? false;
	if(is_public) {
		return (
			<ButtonCollection _class={{ other:'flex_button gui_not_in_top_big gui_big_button' }}>
				{props.children}
			</ButtonCollection>
		)
	}

	return (
		<ButtonCollection in_floating={true} _class={props._class}>
			{props.children}
		</ButtonCollection>
	)
}

const ExportModal = ({filters, dispatch, toggle, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const new_download_center = props?.download_center ?? false; //v24
	const promotion = (props.promotion != undefined) ? props.promotion : false;
	const promotion_id = (props.promotion_id != undefined) ? props.promotion_id : (promotion?.id ?? false);
	if(!promotion_id && !new_download_center) return null;

	const multiparticipation = promotion?.multi_participation ?? false;

	const stages = (props.stages != undefined) ? props.stages : false;
	const prizes = (props.prizes != undefined) ? ((props.prizes.length > 0) ? props.prizes : false) : false;
	const loyalty = promotion?.loyalty_enabled ?? false;
	const message_download_center = <FormattedMessage id="You can download the generated file from Settings > Utilities > {download_center}." values={{download_center:<ActionLink _href={`${window.panel_url}utilities/download_center`}>Download Center</ActionLink>}} />;

	if(new_download_center){
		return (
			<ExportModalDownloadCenter
				toggle={toggle}
				message_download_center={message_download_center}
				{...props}
			/>
		)
	}

	useEffect(() => {
		// ComponentWillMount
		// TO DO > get all promotion info from promotion_id
		// $.get(...)
		return () => {
			// ComponentWillUnmount
		}
	}, []);
	let limit_export = 10000;
	const format_date = (window.is_spanish) ? 'DD-MM-YYYY' : 'YYYY-MM-DD';
	const date_format_db = 'YYYY-MM-DD HH:mm';

	let is_public = props?.is_public ?? false;
	let skip_filters = (props.filtered) ? true : false;
	const type = (props.type != undefined) ? props.type : ((skip_filters) ? 'users_filtered' : 'audience');
	const validation_site =  props.validation_site != undefined && type == 'validation_sites' ? props.validation_site : false;
	
	let type_default = 'user';

	const skip_types = [
		'ranking_single_stage',
		'media_votes',
		'media_results',
		'media_entries',
		'media_files',
		'requeriments_single_stage',
		'instant_wins',
		'zip_files',
		'unused_codes',
		'prizes_all',
		'prizes_single',
		'prizes_single_winners',
		'prizes_single_alternates',
		'users_all',
		'users_single_stage',
		'users_filtered',
		'unsubscribed_emails',
		'coins_balance',
		'coins_transactions',
		'ranking_all',
		'ranking_single_stage',
		'ranking_custom',
		'instant_wins',
	];

	const types_download_center = [
		'zip_files',
		'unused_codes',
		'users_filtered',
		'unsubscribed_emails',
		'media_entries',
		'requeriments_single_stage',
		'prizes_single_winners',
		'prizes_single_alternates',
		'instant_wins',
	]
	const type_exports_download_center = {};
		type_exports_download_center['participations_all'] = ['all'];
		type_exports_download_center['participations_single_stage'] = ['all','prize'];
		type_exports_download_center['prizes_all'] = ['all'];
		type_exports_download_center['prizes_dates'] = ['all'];
		type_exports_download_center['prizes_single'] = ['all'];
		type_exports_download_center['users_all'] = ['all'];
		type_exports_download_center['users_single_stage'] = ['all'];
		type_exports_download_center['users_filtered'] = ['all',null];
		type_exports_download_center['coins_balance'] = ['all','date'];
		type_exports_download_center['coins_transactions'] = ['all'];
		type_exports_download_center['ranking_all'] = ['all'];
		type_exports_download_center['ranking_single_stage'] = ['all'];
		type_exports_download_center['ranking_custom'] = ['all'];

	if(skip_types.includes(type) || validation_site) {
		skip_filters = true;
	}

	let array_exports = [
		{ group:'user', key:'users_all', name:"***All" },
	];

	if(isMultiStage(promotion.promotion_type_id)){
		array_exports.push({ group:'user', key:'users_single_stage', name:"Select a stage", selector:'stage' });
	}

	array_exports.push({ group:'score', key:'ranking_all', name:"Overall"});
	if(isMultiStage(promotion.promotion_type_id)){
		array_exports.push({ group:'score', key:'ranking_single_stage', name:"By stage", selector:'stage'});
	}
	if((promotion?.stage_rankings ?? []).length > 0){
		array_exports.push({ group:'score', key:'ranking_custom', name:"By custom ranking"});
	}

	array_exports.push({ group:'participations', key:'participations_all', name:"All"});
	if(isMultiStage(promotion.promotion_type_id)){
		array_exports.push({ group:'participations', key:'participations_single_stage', name:"Select a stage", selector:'stage' });
	}

	if(prizes) {
		array_exports.push({ group:'prize', key:'prizes_all', name:"***All" });
		array_exports.push({ group:'prize', key:'prizes_dates', name:"By dates" });
		array_exports.push({ group:'prize', key:'prizes_single', name:"Select a prize", selector:'prize' });
	}

	if(loyalty){
		array_exports.push({ group:'coins', key:'coins_balance', name:"Balance", selector:'date'});
		array_exports.push({ group:'coins', key:'coins_transactions', name:"Transactions"});
	}
	if(['ranking_single_stage','ranking_custom'].includes(type))type_default = 'score';
	else if(type == 'codevalidation') {
		array_exports = [
			{ group:'code', key:'codes_all', name:i18n("***All"), autotranslate:false },
		];
		type_default = 'code';
	}else if(['media_entries',
				'media_votes',
				'media_results',
				'media_entries',
				'media_files',
				'requeriments_single_stage',
				'instant_wins',//per esquivar el download_center ja que els types catalogats com a 'user' (default)els inclou
				'validation_sites',
			].includes(type))type_default=null;//No els assignem a cap grup

	const default_export = array_exports.filter((obj) => { return obj.group == type_default; });
	const [ state, setState ] = useState({ email:props?.agent_email ?? null });
	const [ error_email, setErrorEmail ]  = useState(!validateEmail(state.email))
	const [ group, setGroup ] = useState(type_default);
	const [ selected_export_type, setSelectedExportType ] = useState(false);
	const [ selected_prize, setSelectedPrize ] = useState(props?.prize_type_id ?? false);
	const [ active_export_actions, setActiveExportActions ] = useState(default_export);
	const [ selected_stage, setSelectedStage ] = useState(props?.stage_id ?? false);
	const [ success_message, setSuccessMessage ] = useState(false);
	const [ error_message, setErrorMessage ] = useState(false);
	const [ participations_type, setParticipationsType ] = useState(false);
	const [ custom_ranking, setCustomRanking ] = useState(props?.custom_ranking ?? false);
	const [ start_date, setStartDate ] = useState(EPDateFormat(promotion.start_date, date_format_db));
	const [ end_date, setEndDate ] = useState(EPDateFormat(promotion.end_date, date_format_db));
	const [ option_json, setOptionJson ] = useState(false);

	let sections = [{
		label:i18n("Users"),
		onClick:() => goToFilterArea('user'),
		selected:(group == 'user') ? true : false,
	}];

	if(prizes) {
		sections.push({
			label:i18n("Winners"),
			onClick:() => goToFilterArea('prize'),
			selected:(group == 'prize') ? true : false,
		});
	}

	if(with_score(promotion.promotion_type_id)){
		sections.push({
			label:i18n("Ranking"),
			onClick:() => goToFilterArea('score'),
			selected:(group == 'score') ? true : false,
			enabled:multiparticipation
		});
	}

	sections.push({
		label:i18n("Participations"),
		onClick:() => goToFilterArea('participations'),
		selected:(group == 'participations') ? true : false,
		enabled:multiparticipation
	});

	if(type == 'codevalidation') {
		sections = [{
			label:i18n("Prizes redeemed"),
			onClick:() => goToFilterArea('code'),
			selected:(group == 'code') ? true : false,
			enabled:multiparticipation
		}];
	}

	sections.push({
		label:i18n("Virtual coins"),
		onClick:() => goToFilterArea('coins'),
		selected:(group == 'coins') ? true : false,
		enabled:loyalty
	});

	const goToFilterArea = (group_name) => {
		setExportType(0);
		setGroup(group_name);
		let exported_elements = array_exports.filter((obj)=> {return obj.group == group_name});
		setActiveExportActions(exported_elements);
		setSelectedExportType(false);
		setSelectedStage(false);
		setSelectedPrize(false);
		setParticipationsType(false);
		setCustomRanking(null);
	};
	useEffect(() => {
		if(!selected_stage && (['score','user','participations'].includes(group)) && !isMultiStage(!promotion.promotion_type_id) && stages.length == 1){
			setSelectedStage(stages[0].k)	
		}
	}, [group]);
	const stage = props?.stage?.Stage ?? {};
	const is_requirements_ocr_ticket = (type == 'requeriments_single_stage' && stage.reqs_type == '8') ? true : false;

	const type_download_selected = selected_export_type?.key ?? null;
	const complete_group_download_center = ['user','prize','participations','coins','score'];
	const is_download_center = types_download_center.includes(type) || 
								(Object.keys(type_exports_download_center)).includes(type_download_selected) &&  
									(type_exports_download_center[type_download_selected].includes(participations_type) || !participations_type);
	const download_csv = (cb) => {
		let send_info = {};
		if(props.filename != undefined) send_info.filename = props.filename;

		let valid_email = validateEmail(state.email);
		setErrorEmail(!valid_email);
		if(!valid_email){
			if (cb != undefined)cb();
			return false;
		}
		send_info.email = state.email;
		if(state.password)send_info.password = state.password;
		console.log('type',type)
		if(!skip_filters || type == 'users_filtered') {
			if((props.filtered === false && selected_export_type === false) || error_email) return null;

			//let send_info = {remotedb:1};
			if(props.filtered) {
				send_info.type = 'users_filtered';
				var result = (props.filtered).map((a)=>{return a.User.login_id});
				const login_ids = JSON.stringify(result);
				send_info.login_ids = login_ids;
			} else {
				send_info.type = selected_export_type.key;
			}
		} else {
			send_info.type = type;
			if(props.filtered){
				var result = (props.filtered).map((a)=>{return a.Participation ? a.Participation.id : a.User.id });
				send_info.participation_ids = JSON.stringify(result);
			} else if(validation_site) {
				send_info.validation_site_ids = [validation_site.id];
			}
			
			if(type == 'prizes_single_winners' || type == 'prizes_single_alternates'){//desde pagina de ganadores
				send_info.type = 'prizes_single';
				send_info.assignation = 2;//premi Aleatori
				if(type == 'prizes_single_winners')send_info.only_winners = true;
				if(type == 'prizes_single_alternates')send_info.only_alternates = true;
			}
		}
		
		if(['participations','prize'].includes(group) || ['coins'].includes(group) && participations_type == 'until_date') {
			//send_info.limit = limit_export;
			send_info.end_date = end_date;
		}
		if(['prize'].includes(group)) send_info.assignation = (prizes ?? []).find(p => p.k == selected_prize)?.assignation ?? null

		if(['prize'].includes(group) && send_info.type == 'prizes_dates') {
			//send_info.limit = limit_export;
			send_info.start_date = start_date;
			send_info.end_date = end_date;
		}

		if(['score'].includes(group) && send_info.type == 'ranking_custom') {
			send_info.custom_ranking = custom_ranking;
		}


		if(selected_stage !== false) send_info.stage = selected_stage;
		if(selected_prize !== false) send_info.prize = selected_prize;
		if(participations_type !== false) send_info.participations_type = participations_type;
		if(option_json !== false)send_info.json_data = option_json;
		if(props.extra_data != undefined){
			send_info = {...send_info, ...props.extra_data};
		}

		$.post(getRemotedbUrl(`/utils/export/${promotion_id}`),send_info,(result)=>{
			if(result.status){
				setSuccessMessage(true);
				if(!skip_filters && !is_download_center){
					setSelectedExportType(false);
					setSelectedStage(false);
					setSelectedPrize(false);
					setParticipationsType(false);
					setCustomRanking(null);
				}
				setTimeout(() => {
					//setSuccessMessage(false);
				}, 10000);
			}else{
				setErrorMessage(result);
			}
			if (cb != undefined)cb();
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});;
	};

	const setExportType = (index) => {
		setSelectedExportType(active_export_actions[index]);
		setSelectedStage(false);
		setSelectedPrize(false);
		setParticipationsType(false);
		setCustomRanking(null);
	};

	const selectStage = (id) => {
		setSelectedStage(id);
	};

	const selectPrize = (id) => {
		setSelectedPrize(id);
	};

	const change = (k, v) => {
		state[k] = v;
		setState({ ...state });
		if(k == 'email'){
			let valid_email = validateEmail(v);
			setErrorEmail(!valid_email);
		}
	};
	let has_prizes_stage = (group == 'participations' && selected_stage && prizes && prizes.find( p => p.stage_id == selected_stage || p.stage_id == null) !== null) ? true : false;
	let has_balance_option_selected = (group == 'coins' && ['all','until_date'].includes(participations_type)) ? true : false;
	let export_button_disabled = true;

	if((props.filtered || skip_filters) && !error_email) {
		export_button_disabled = false;
	}else if(selected_export_type !== false  && selected_export_type.key == 'ranking_custom'){
		export_button_disabled = custom_ranking ? false : true;
	}else if(((selected_export_type !== false && selected_export_type.selector == undefined) ||
		(selected_export_type.selector != undefined && has_balance_option_selected) ||
		(selected_export_type.selector != undefined && selected_stage !== false && !has_prizes_stage) ||
		(selected_export_type.selector != undefined && selected_stage !== false && participations_type !== false && has_prizes_stage) ||
		(selected_export_type.selector != undefined && selected_prize !== false)) && selected_export_type.group!=undefined && selected_export_type.group == group && !error_email) {
		export_button_disabled = false;
	}

	const total_steps_passed = (selected_export_type !== false && (selected_export_type.selector != undefined || selected_export_type.key == 'ranking_custom')) ? 2 : 1;
	const min_cols_to_display = 3;

	let pending_cols = [];
	if(total_steps_passed < min_cols_to_display + 1 && type_default != 'code') {
		for(var i = total_steps_passed + 1; i < min_cols_to_display; i++) {
			pending_cols.push(i);
		}
	}

	let title = props?.title ?? i18n("Export data");
	let total_filtered = 0;
	if(props.filtered) {
		title = (props.type_filtered == 'participations') ? i18n("Export participations") : i18n("Export users");
		total_filtered = props.type_filtered == 'participations' ? props.filtered.reduce((total, actual) => total + parseInt(actual.User.invitations), 0) : props.filtered.length
	}

	let subtitle = (props.filtered) ? <FormattedMessage id="The action will apply to {total_users} user(s)" values={{total_users:<strong>{total_filtered}</strong>}} /> : i18n("Choose the type of data you want to export as a CSV file. We'll send it via email.");
	if(!props.filtered && skip_filters)subtitle = i18n("A CSV file will be generated, and notification will be sent via email to download it.")

	if(type == 'requeriments_single_stage') {
		title = i18n("Export requirements");
	}

	if(type == 'media_votes') {
		let participation = props.filtered ? props.filtered[0].Participation : [];
		title = !props.filtered ? i18n("Export all votes") : i18n("Export votes from") + ' ' + participation.name;
		subtitle = false;
	}

	if(type == 'media_results') {
		title = i18n("Export results");
		subtitle = false;
	}

	if(validation_site) {
		title = i18n("Export validations");
		subtitle = false;
	}

	if (props.subtitle != undefined) {
		subtitle = props.subtitle
	}

	let Component = FloatingLayer;
	let floating_props = {};

	if(!is_public) {
		if(toggle) {
			floating_props.backButton = () => {
				setSuccessMessage(false);
				toggle(false);
			}
		}
		floating_props._class={size:skip_filters?'small':'normal'};
	} else {
		Component = FloatingLayerPublic;
		floating_props.title = title;
		floating_props.is_builder = false;
		floating_props.backButton = toggle;
		floating_props.pm = props?.promotion || {};
	}

	let send_text = props.send_text ?? 'Send generated CSV file to this email';
	let send_button = props.send_button ?? 'Download now';
	let messageOK = i18n("When the job is complete, you will receive an email with a link to download the information requested to the following address")+': <strong>'+state.email+'</strong>';

	if(is_download_center){
		messageOK = props.intl.formatMessage({ id:"The task may take a few minutes. Once the task is completed, a notification will be sent to the email {email}." }, { email:`<strong>${state.email}</strong>`});
		send_button= "Download now";
	}

	if(is_download_center && error_message) {
		let label_error = '';
		let title_error = "Pending download";
		switch(error_message.reason){
			case 'no_brand_organizer':
				title_error = "Export file not allowed"
				label_error = <FormattedMessage id="File export is not possible. The promotion must have an assigned organizing brand." />
			break;
			case 'pending_event':
				label_error = <FormattedMessage id="A recent download of this type already exists in your {link}. Wait until {date} before starting another download." values={{link:<ActionLink _href={`${window.panel_url}utilities/download_center`}>Download Center</ActionLink>,date:error_message?.date ?? null}} />
			break;
			default:
				label_error = <FormattedMessage id="The file download cannot be completed" />;
			break;
		}

		return (
			<Component {...floating_props}>
				<div class="gui_filter_layer">
					<div class="gui_pos_rel">
						<SectionTitle _class={{icon:'knk-download'}} autotranslate={false}>{title}</SectionTitle>
						<InformationMessage
							_class={{ other:'in_bottom' }}
							title={title_error}>{label_error}
						</InformationMessage>
					</div>

					<ExportModalActions is_public={is_public}>
						<SecondaryButton
							onClick={() => toggle(false)}
						>Close</SecondaryButton>
					</ExportModalActions>
				</div>
			</Component>
		)
	}else if(error_message){

		return (
			<Component {...floating_props}>
				<div class="gui_filter_layer">
					<div class="gui_pos_rel">
						<AlertMessage
							_class={{ other:'in_bottom' }}
							title="Error">
								<p>{i18n("The file download cannot be completed")}</p>
						</AlertMessage>
					</div>

					<ExportModalActions is_public={is_public}>
						<SecondaryButton
							onClick={() => toggle(false)}
						>Close</SecondaryButton>
					</ExportModalActions>
				</div>
			</Component>
		)
	}

	if(success_message) {
		return (
			<Component {...floating_props}>
				<div class="gui_filter_layer">
					<div class="gui_pos_rel">
						{(!is_public) && (
							<SectionTitle _class={{icon:'knk-download'}} autotranslate={false}>{title}</SectionTitle>
						)}

						{(subtitle) && (
							<SectionSubtitle autotranslate={false}>{subtitle}</SectionSubtitle>
						)}

						<SuccessMessage
							_class={{ other:'in_bottom' }}
							title="In process"
						>
							<p>{is_download_center ? i18n("Your request has been queued for download.") : i18n("Your request has been queued. The task can take some minutes.")}</p>

							<p dangerouslySetInnerHTML={{ __html:messageOK}} />

							<p>{is_download_center ? message_download_center : i18n("Note: please, check your spam folder if you don't receive the email in the next 10 minutes.")}</p>
						</SuccessMessage>
					</div>

					<ExportModalActions is_public={is_public}>
						<SecondaryButton
							onClick={() => toggle(false)}
						>Close</SecondaryButton>
					</ExportModalActions>
				</div>
			</Component>
		)
	}

	let stage_start_date,stage_end_date;
	if(selected_stage) {
		let _stage = props.stages.find((s) => s.k == selected_stage);
		//stage_start_date = _stage.start_date != '0000-00-00 00:00:00' ? _stage.start_date : props.promotion.start_entry;
		stage_start_date = props.promotion.start_date;
		//stage_end_date = _stage.end_date != '0000-00-00 00:00:00' ? _stage.end_date : props.promotion.end_entry;
		stage_end_date = props.promotion.end_date;
	}
	let show_only_with_prize_in_participations = false;
	if(prizes) {
		/*
		TYPE_MANUAL = '1';
		TYPE_RANDOM = '2';
		TYPE_ON_REGISTER = '3';
		TYPE_INSTANT_WIN = '4';
		TYPE_ROULETTE = '5';
		*/
		show_only_with_prize_in_participations = (prizes.filter((pr) => { 
		return ['3', '4', '5'].indexOf(pr.assignation) > -1 && 
			(pr.stage_id == null || pr.stage_id == selected_stage) 
		}).length > 0) ? true : false;
	}

	return (
		<Component {...floating_props}>
			<div class="gui_filter_layer">
				<div class="gui_pos_rel">
					{(!is_public) && (
						<SectionTitle _class={{icon:'knk-download'}} autotranslate={false}>{title}</SectionTitle>
					)}

					{(subtitle) && (
						<SectionSubtitle autotranslate={false}>{subtitle}</SectionSubtitle>
					)}

					{(!skip_filters) && (
						<>
							<NavigationTabs
								active={group}
								sections={sections}
								display_type='tab'
								_class={{other:'not_in_top'}}
							/>

							<section class={`filter_boxes${(sections.length > 0) ? ' with_tabs' : ''}`}>
								<div>
									<div class="filter_column">
										<div class="gui_buttoned_actions visible_overflowed_container">
											{active_export_actions.map((item, i) => {
												const selected = (selected_export_type.key != undefined && selected_export_type.key == item.key) ? true : false;

												return (
													<span key={`item_${i}`} class={((selected) ? 'selected' : null)}>
														<ActionButton
															_fullclass="cutTextOnOverflow"
															onClick={() => setExportType(i)}
															autotranslate={false}
														>{i18n(item.name).replace("***","")}</ActionButton>
													</span>
												)
											})}
										</div>
									</div>
								</div>

								{(selected_export_type !== false && (selected_export_type.selector != undefined)) && (
									<>
										<div>
											<div class="filter_column">
												<div class="gui_buttoned_actions visible_overflowed_container">
													{selected_export_type.selector == 'stage' && stages.map((stage, s) => {
														const selected = (selected_stage != undefined && stage.k == selected_stage) ? true : false;
														return (
															<span key={`stage_${s}`} class={((selected) ? 'selected' : null)}>
																<ActionButton
																	_fullclass="cutTextOnOverflow"
																	onClick={() => selectStage(stage.k)}
																>{stage.v}</ActionButton>
															</span>
														)
													})}

													{selected_export_type.selector == 'prize' && prizes.map((prize, s) => {
														const selected = (selected_prize != undefined && prize.k == selected_prize) ? true : false;
														return (
															<span key={`prize_${s}`} class={((selected) ? 'selected' : null)}>
																<ActionButton
																	_fullclass="cutTextOnOverflow"
																	onClick={() => selectPrize(prize.k)}
																>{prize.v}</ActionButton>
															</span>
														)
													})}

													{(group == 'coins' && selected_export_type.selector == 'date') && (
														<>
															<span class={((participations_type == 'all') ? 'selected' : null)}>
																<ActionButton
																	_fullclass="cutTextOnOverflow"
																	onClick={() => setParticipationsType('all')}
																>Current</ActionButton>
															</span>

															<span class={((participations_type == 'until_date') ? 'selected' : null)}>
																<ActionButton
																	_fullclass="cutTextOnOverflow"
																	onClick={() => setParticipationsType('until_date')}
																	>At a date</ActionButton>
															</span>
														</>
													)}
												</div>
											</div>
										</div>
 
										{(group == 'participations' && selected_export_type.selector == 'stage' && selected_stage && has_prizes_stage) && (
											<div>
												<div class="filter_column">
													<div class="gui_buttoned_actions visible_overflowed_container">
														<span class={((participations_type == 'all') ? 'selected' : null)}>
															<ActionButton
																_fullclass="cutTextOnOverflow"
																onClick={() => setParticipationsType('all')}
															>All</ActionButton>
														</span>

														{(show_only_with_prize_in_participations) && (
															<span class={((participations_type == 'prize') ? 'selected' : null)}>
																<ActionButton
																	_fullclass="cutTextOnOverflow"
																	onClick={() => setParticipationsType('prize')}
																	>Only with prize</ActionButton>
															</span>
														)}
													</div>
												</div>
											</div>
										)}
									</>
								)}

								{(group == 'score' && selected_export_type.key == 'ranking_custom') && (
									<div>
										<div class="filter_column">
											<div class="gui_buttoned_actions visible_overflowed_container">
												{(promotion?.stage_rankings ?? []).map((ranking) => {
													return (
														<span class={((custom_ranking == ranking.id) ? 'selected' : null)}>
															<ActionButton
																_fullclass="cutTextOnOverflow"
																onClick={() => setCustomRanking(ranking.id)}
															>{ranking.title}</ActionButton>
														</span>
													)
												})}
											</div>
										</div>
									</div>
								)}

								{pending_cols.map((empty_col, c) => {
									return (
										<div key={`empty_col_${c}`}>
											<div class="empty_section">
												<p><strong>{i18n("Select an item from the left")}</strong></p>
												<p>{i18n("Additional options will show here")}</p>
											</div>
										</div>
									)
								})}
							</section>
						</>
					)}

					<div class={(!skip_filters) ? 'not_in_top' : ''}>
						{(!is_download_center && !complete_group_download_center.includes(group)) ? (
							//Grups que son completament downloadCenter (default sense seleccionar opcio(Nomes TAB) => email ocult)
							<div>
								<EmailField
									model={state}
									change={change}
									_class={{ first:true }}
									passed={(valid) => setErrorEmail(!valid)}
									autocomplete={true}
									name="email"
									error_msg_position_class={error_email}
								>{send_text}</EmailField>
								{(type == 'validation_sites') && (
									<Input
										model={state}
										change={change}
										autocomplete={false} 
										name="password" 
										placeholder="Password"
										 _type="password"
									>Validation point identification</Input>
								)}
							</div>
						) : (
							<>
								<p>{i18n("The generated file can be downloaded from Settings > Utilities > Download Center.")}</p>
								{(is_requirements_ocr_ticket) && (
									<Checkbox value={option_json} change={(k,v) => setOptionJson(v)}>Include ticket JSON data obtained with AI</Checkbox>
								)}
							</>
						)}
						

						{(group == 'coins' && selected_export_type.selector == 'date' && participations_type == 'until_date')
							&& (
							<Message
								icon={false}
								_class={{ other:'in_bottom' }}
							>
								<DateTimePicker
									_class={{first:true,size:30}}
									format={format_date}
									name="endDate"
									show_time={true}
									position="top-start"
									change={(k, v) => setEndDate(v.format(date_format_db))}
									time_interval={30}
									value={end_date}
									min_date={stage_start_date}
									max_date={stage_end_date}
								>Select a specific date to view the users' balance</DateTimePicker>
							
							</Message>
						)}
						{(group == 'prize' && selected_export_type.key == 'prizes_dates')	&& (
							<Message
								icon={false}
								_class={{ other:'in_bottom' }}
							>	
								<div class="gui_equal_columns gui_padded_children_low">
									<DateTimePicker
										_class={{first:true,size:50}}
										format={format_date}
										name="startDate"
										show_time={true}
										position="top-start"
										change={(k, v) => setStartDate(v.format(date_format_db))}
										time_interval={30}
										value={start_date}
										min_date={stage_start_date}
										max_date={end_date}
									>Start date</DateTimePicker>

									<DateTimePicker
										_class={{first:true,size:50}}
										format={format_date}
										name="endDate"
										show_time={true}
										position="top-start"
										change={(k, v) => setEndDate(v.format(date_format_db))}
										time_interval={30}
										value={end_date}
										min_date={start_date}
										max_date={stage_end_date}
									>End date</DateTimePicker>
								</div>
							</Message>
						)}

						{(group == 'participations' && false) && (
							<Message
								icon={false}
								_class={{ other:'in_bottom' }}
							>
								<p>
									<FormattedMessage
										id="The export is limited to {limit} participations per file."
										values={{limit:milesNumber(limit_export)}}
									/>
								</p>

								<p>
									<FormattedMessage
										id="If you have more than {limit} participations, use the date selector to generate different files. Each file will include the last {limit} participations starting from the date you selected."
										values={{limit:milesNumber(limit_export)}}
									/>
								</p>

								<DateTimePicker
									_class={{first:true,size:30}}
									format={format_date}
									name="endDate"
									position="top-start"
									change={(k, v) => setEndDate(v.format(date_format_db))}
									time_interval={30}
									value={end_date}
									min_date={stage_start_date}
									max_date={stage_end_date}
								>Select the date from which you want to export the participations</DateTimePicker>
							</Message>
						)}
					</div>
				</div>

				<ExportModalActions
					is_public={is_public}
				>
					<SaveButton
						disabled={(export_button_disabled) ? true : false}
						onClick={(e, cb) => download_csv(cb)}
					>{send_button}</SaveButton>
				</ExportModalActions>
			</div>
		</Component>
	);
}

export default injectIntl(ExportModal);